import { EmptyState } from '../../../components/EmptyState';
import { Spinner } from '../../../components/Spinner';
import { useGetMyBooksQuery } from '../api/booksApi';
import { BookType } from '../api/types';
import { BookRow } from './BookRow';

type ActiveBooksProps = {
  isActivePage: boolean;
  onDeletePress: (book: BookType) => void;
  onEditPress: (book: BookType) => void;
};
export const ActiveBooks = ({ isActivePage, onDeletePress, onEditPress }: ActiveBooksProps) => {
  const { data: books, isLoading: loadingBooks } = useGetMyBooksQuery(undefined, {
    skip: !isActivePage
  });

  if (loadingBooks) {
    return (
      <div className="w-full h-[50vh] flex justify-center items-center">
        <Spinner />
      </div>
    );
  }
  return (
    <>
      {books && books?.count > 0 ? (
        books?.results.map((book) => (
          <BookRow
            key={book.id}
            book={book}
            onDeletePress={onDeletePress}
            onEditPress={onEditPress}
          />
        ))
      ) : (
        <EmptyState text="No books found" />
      )}
    </>
  );
};
